var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view-wrapper',{staticClass:"trailer",attrs:{"header-text":"Trailer","no-offset":""}},[_c('youtube-video',{attrs:{"video-id":_vm.TRAILER_YOUTUBE_ID,"controls":true,"poster-src":"/img/poster.png","poster-delay":"250"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }